<template>
    <v-layout
        class="fill-height"
    >
        <v-navigation-drawer
            class="filter-navigation pt-16"
            :permanent="!$vuetify.breakpoint.smAndDown"
            :absolute="$vuetify.breakpoint.smAndDown"
            v-model="filterDrawer"
            width="300"
        >
            <form
                class="pa-4"
            >
                <v-text-field
                    v-model="filter.tourCode"
                    :label="$t('services.filter.tourCode')"
                />
                <v-text-field
                    v-model="filter.search"
                    :label="$t('services.filter.search')"
                />
                <v-dialog
                    ref="serviceStartDialog"
                    v-model="serviceStartModal"
                    :return-value.sync="filter.serviceStart"
                    persistent
                    width="290px"
                >
                    <template
                        v-slot:activator="{ on, attrs }"
                    >
                        <v-text-field
                            v-model="filter.serviceStart"
                            :label="$t('services.filter.serviceStart')"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="filter.serviceStart"
                        :max="filter.serviceEnd"
                        scrollable
                    >
                        <v-spacer/>
                        <v-btn
                            text
                            @click="serviceStartModal = false; $refs.serviceStartDialog.save(null)"
                        >
                            {{ $t('action.cancel') }}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.serviceStartDialog.save(filter.serviceStart)"
                        >
                            {{ $t('action.ok') }}
                        </v-btn>
                    </v-date-picker>
                </v-dialog>
                <v-dialog
                    ref="serviceEndDialog"
                    v-model="serviceEndModal"
                    :return-value.sync="filter.serviceEnd"
                    persistent
                    width="290px"
                >
                    <template
                        v-slot:activator="{ on, attrs }"
                    >
                        <v-text-field
                            v-model="filter.serviceEnd"
                            :label="$t('services.filter.serviceEnd')"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="filter.serviceEnd"
                        :min="filter.serviceStart"
                        scrollable
                    >
                        <v-spacer/>
                        <v-btn
                            text
                            @click="serviceEndModal = false; $refs.serviceEndDialog.save(null)"
                        >
                            {{ $t('action.cancel') }}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.serviceEndDialog.save(filter.serviceEnd)"
                        >
                            {{ $t('action.ok') }}
                        </v-btn>
                    </v-date-picker>
                </v-dialog>
                <v-btn
                    @click="resetFilter"
                >
                    {{ $t('action.reset') }}
                </v-btn>
            </form>
        </v-navigation-drawer>
        <v-row>
            <v-col
                cols="12"
            >
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :loading="isLoading"
                    :server-items-length="total"
                    :options.sync="options"
                    :footer-props="{ itemsPerPageOptions: [10, 15, 30] }"
                >
                    <template
                        v-slot:item._status="{ item }"
                    >
                        <service-status :status="item.service_request_state"/>
                    </template>
                    <template
                        v-slot:item.service_room_type="{ item }"
                    >
                        {{ $t(`rooms.${item.service_room_type}`) }}
                    </template>
                    <template
                        v-slot:item.service_start="{ item }"
                    >
                        {{ new Date(item.service_start).toLocaleDateString() }}
                    </template>
                    <template
                        v-slot:item.service_end="{ item }"
                    >
                        {{ new Date(item.service_end).toLocaleDateString() }}
                    </template>
                    <template
                        v-slot:item.booking_request_deadline="{ item }"
                    >
                        {{ new Date(Date.parse(item.booking_request_deadline)).toLocaleString() }}
                    </template>
                    <template
                        v-slot:item._actions="{ item }"
                    >
                        <div
                            v-if="new Date(item.booking_request_deadline) > new Date()"
                        >
                            <v-btn
                                class="mr-4"
                                @click="dialogCancel = true; activeService = item"
                                small
                                :disabled="item.service_request_state !== 1 && item.service_request_state !== 0"
                            >
                                {{ $t('services.action.decline') }}
                            </v-btn>
                            <v-btn
                                @click="dialogAccept = true; activeService = item"
                                small
                                color="primary"
                                :disabled="item.service_request_state !== 1 && item.service_request_state !== 0"
                            >
                                {{ $t('services.action.accept') }}
                            </v-btn>
                        </div>
                        <div
                            v-else
                            class="d-flex"
                        >
                            <v-alert
                                outlined
                                type="warning"
                                dense
                                class="ma-0"
                            >
                                {{ $t('services.text.expired') }}
                            </v-alert>
                        </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialogCancel"
            persistent
            width="400"
        >
            <v-card
                :loading="isSaving"
            >
                <v-card-title>
                    {{ $t('services.text.decline') }}
                </v-card-title>
                <v-divider/>
                <v-card-actions>
                    <v-btn
                        text
                        @click="dialogCancel = false"
                        :disabled="isSaving"
                    >
                        {{ $t('action.cancel') }}
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        primary
                        @click="decline()"
                        :disabled="isSaving"
                    >
                        {{ $t('action.confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogAccept"
            persistent
            width="400"
        >
            <v-card
                :loading="isSaving"
            >
                <v-card-title>

                </v-card-title>
                <v-card-text>
                    {{ $t('services.text.accept') }}
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-btn
                        text
                        @click="dialogAccept = false"
                        :disabled="isSaving"
                    >
                        {{ $t('action.cancel') }}
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        primary
                        @click="accept()"
                        :disabled="isSaving"
                    >
                        {{ $t('action.confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {SnackBarAction} from "@/store/snackbar/types";
import {ServiceActions} from "@/store/services/types";
import {debounce} from "debounce";
import ServiceStatus from "@/components/Service/ServiceStatus";

export default {
    components: {ServiceStatus},
    mounted() {
        this.loadServicesDebounce = debounce(this.loadServices, 500);
        let start = new Date();
        start.setDate(start.getDate() + 1);
        this.filter.serviceStart = start.toISOString().split('T')[0];
    },
    data: () => ({
        filterDrawer: false,
        dialogAccept: false,
        dialogCancel: false,
        activeService: null,
        options: {
            sortBy: ['service_start'],
            sortDesc: [false],
            page: 1,
            itemsPerPage: 10,
        },
        filter: {
            tourCode: null,
            search: null,
            serviceStart: null,
            serviceEnd: null,
        },
        serviceStartModal: false,
        serviceEndModal: false,
    }),
    watch: {
        options: {
            handler() {
                this.loadServices();
            },
            deep: true,
        },
        filter: {
            handler() {
                this.loadServicesDebounce();
            },
            deep: true,
        },
        modalActive(newValue) {
            if(
                newValue === false
            ) {
                this.loadServices();
            }
        }
    },
    computed: {
        ...mapGetters({
            items: 'services/services',
            total: 'services/total',
            isLoading: 'services/isLoading',
            isSaving: 'services/isSaving',
        }),
        headers() {
            return [
                {
                    text: this.$t('services.headers.status'),
                    value: '_status',
                    sortable: false,
                },
                {
                    text: this.$t('services.headers.amount'),
                    value: 'service_request_quantity',
                    sortable: false,
                },
                {
                    text: this.$t('services.headers.roomType'),
                    value: 'service_room_type',
                    sortable: false,
                },
                {
                    text: this.$t('services.headers.serviceStart'),
                    value: 'service_start',
                },
                {
                    text: this.$t('services.headers.serviceEnd'),
                    value: 'service_end',
                    sortable: false,
                },
                {
                    text: this.$t('services.headers.customerName'),
                    value: 'booking_customer_name',
                    sortable: false,
                },
                {
                    text: this.$t('services.headers.bookingNo'),
                    value: 'booking_no',
                },
                {
                    text: this.$t('services.headers.deadline'),
                    value: 'booking_request_deadline',
                    sortable: false,
                },
                {
                    text: this.$t('services.headers.tourCode'),
                    value: 'tour_code',
                    sortable: false,
                },
                {
                    text: this.$t('services.headers.actions'),
                    value: '_actions',
                    sortable: false,
                },
            ];
        },
    },
    methods: {
        ...mapActions({
            load: `services/${ServiceActions.LOAD}`,
            setSnackbar: `snackbar/${SnackBarAction.SET}`,
            acceptService: `services/${ServiceActions.CONFIRM}`,
            declineService: `services/${ServiceActions.DECLINE}`,
        }),
        loadServices() {
            this.load({
                options: this.options,
                filter: this.filter,
            });
        },
        accept() {
            this.acceptService({
                id: this.activeService.service_request_id,
            }).then(() => {
                this.dialogAccept = false;
                this.activeService = null;
            });

        },
        decline() {
            this.declineService({
                id: this.activeService.service_request_id,
            }).then(() => {
                this.dialogCancel = false;
                this.activeService = null;
            });
        },
        resetFilter() {
            let start = new Date();
            start.setDate(start.getDate() + 1);
            this.filter = {
                tourCode: null,
                search: null,
                serviceStart: start.toISOString().split('T')[0],
                serviceEnd: null,
            };
        },
    },
}
</script>
